// Module
import { Link } from 'react-router-dom';
// CSS
import '_Asset/css/User/Include/footer.css'
// Component


const Footer = () => {

	return (
		<footer>
      <div className="section">
        <div className="footerGroup">
          <p>&copy; PayGate Co., Ltd.</p>

          <ul className="footerMenu">
            <li><Link to="/addition/terms-of-service">서비스 약관</Link></li>
            <li><Link to="/addition/privacy-policy">개인정보 처리방침</Link></li>
            <li><Link to="/addition/developer-employ">개발자 채용</Link></li>
          </ul>
        </div>
      </div>
		</footer>
	)
}

export default Footer;